<template>
  <v-row>
    <v-col cols="12">
      <v-card class="elevation-3">
        <v-row>
          <v-col cols="12">
            <ProductTypes :types="productTypes" />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <PriceOnePoint
              v-if="points.length == 1"
              :products="products"
              :point="points[0]"
              :productsStates="productsStates"
            />
            <PriceManyPoints
              v-else
              :products="products"
              :points="points"
              :productsStates="productsStates"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Icon } from "@/helpers";

import ProductTypes from "@/components/Orders/ProductTypes";
import PriceOnePoint from "@/components/Orders/PriceOnePoint";
import PriceManyPoints from "@/components/Orders/PriceManyPoints";

export default {
  props: {
    products: Array,
    points: Array,
    productTypes: Array,
    productsStates: Array,
  },
  components: {
    ProductTypes,
    PriceOnePoint,
    PriceManyPoints,
  },
  computed: {},
  methods: {},
  data: () => ({}),
};
</script>
